export default "__VITE_ASSET__BRGblgFM__"